import { useMotionValueEvent, useScroll } from "framer-motion";
import { useState } from "react";

export type ScrollDirection = "up" | "down";

/**
 * A custom hook that returns the direction of the scroll action.
 * @param scrollTopThreshold The threshold of the scrollTop after which the scroll direction should be calculated.
 * @param scrollThreshold  The threshold after which the scroll direction should be recalculated.
 * @returns An object containing the scroll direction.
 */
export const useScrollDirection = (
  scrollTopThreshold = 100,
  scrollThreshold = 50
): { scrollDirection: ScrollDirection; isScrollUp: boolean } => {
  const { scrollY } = useScroll();
  const [scrollStatus, setScrollStatus] = useState<{ position: number; direction: ScrollDirection }>({
    position: 0,
    direction: "up",
  });

  useMotionValueEvent(scrollY, "change", (position) => {
    if (position < scrollTopThreshold) return;
    if (Math.abs(scrollStatus.position - position) < scrollThreshold) return;

    setScrollStatus((prevState) => ({
      ...prevState,
      position,
      direction: prevState.position > position ? "up" : "down",
    }));
  });

  return { scrollDirection: scrollStatus.direction, isScrollUp: scrollStatus.direction === "up" };
};
